import type { ImpuestoDeGasto } from './tipos';

/**
 * Lo que costó una compra antes de impuestos: el total pagado menos lo que se cobró por cada tributo.
 * Se teclea el total, que es lo que dice el recibo; el subtotal sale solo. Sin total no hay subtotal.
 */
export function subtotalDeGasto(total: number | null, impuestos: ImpuestoDeGasto[]): number | null {
  if (total === null) return null;
  return Math.round(total - impuestos.reduce((suma, i) => suma + (i.monto || 0), 0));
}

/**
 * El tributo que no se puede guardar: uno de tipo `otro` sin nombre. IVA e INC se identifican por su
 * tipo; lo demás solo se sabe por el nombre que declaró el proveedor.
 */
export function impuestoSinNombre(impuestos: ImpuestoDeGasto[]): boolean {
  return impuestos.some((i) => i.tipo === 'otro' && (i.nombre ?? '').trim() === '');
}
